export const DELIVERY_MAP_BANNER_TEST_ID = {
  root: 'delivery-map-banner',
  link: 'delivery-link'
};
